import { render, staticRenderFns } from "./BanListView.vue?vue&type=template&id=4e50b0ce&scoped=true&"
import script from "./BanListView.vue?vue&type=script&lang=js&"
export * from "./BanListView.vue?vue&type=script&lang=js&"
import style0 from "./BanListView.vue?vue&type=style&index=0&id=4e50b0ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50b0ce",
  null
  
)

export default component.exports